import { useEffect, useState } from "react";
import { apiFetch } from "./api";

const initialForm = {
  name: "",
  email: "",
  role: "athlete",
  team: "",
  squad: "",
  position: "",
  graduation_year: "",
  age_group: "",
};

export default function CreateUserModal({
  open,
  onClose,
  onCreated,
  teams = [],
  squads = [],
  positions = [],
}) {
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(initialForm);
      setError("");
      setSaving(false);
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setError("Name is required");
      return;
    }
    if (!form.email.trim()) {
      setError("Email is required");
      return;
    }

    setSaving(true);
    setError("");
    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        role: form.role,
        team: form.team.trim() ? form.team.trim() : null,
        squad: form.squad.trim() ? form.squad.trim() : null,
        position: form.position.trim() ? form.position.trim() : null,
        graduation_year: form.graduation_year.trim() ? form.graduation_year.trim() : null,
        age_group: form.age_group.trim() ? form.age_group.trim() : null,
      };

      await apiFetch("/users", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (typeof onCreated === "function") onCreated();
      onClose();
    } catch (e) {
      setError(e?.message || "Failed to create user");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard roster-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="modal-close"
          aria-label="Close create user modal"
          onClick={onClose}
        >
          &times;
        </button>
        <div className="roster-modal-header">
          <h3 className="h2 roster-modal-title">Create User</h3>
        </div>
        <div className="stack roster-modal-body">
          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Name</span>
            <input
              className="input"
              value={form.name}
              onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
              placeholder="Full name"
            />
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Email</span>
            <input
              className="input"
              type="email"
              value={form.email}
              onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="name@example.com"
            />
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Role</span>
            <select
              className="input"
              value={form.role}
              onChange={(e) => setForm((prev) => ({ ...prev, role: e.target.value }))}
            >
              <option value="athlete">Athlete</option>
              <option value="coach">Coach</option>
              <option value="parent">Parent</option>
            </select>
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Team</span>
            <select
              className="input"
              value={form.team}
              onChange={(e) => setForm((prev) => ({ ...prev, team: e.target.value }))}
            >
              <option value="">—</option>
              {teams.map((team) => (
                <option key={team} value={team}>
                  {team}
                </option>
              ))}
            </select>
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Squad</span>
            <select
              className="input"
              value={form.squad}
              onChange={(e) => setForm((prev) => ({ ...prev, squad: e.target.value }))}
            >
              <option value="">—</option>
              {squads.map((squad) => (
                <option key={squad} value={squad}>
                  {squad}
                </option>
              ))}
            </select>
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Position</span>
            <select
              className="input"
              value={form.position}
              onChange={(e) => setForm((prev) => ({ ...prev, position: e.target.value }))}
            >
              <option value="">—</option>
              {positions.map((position) => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Graduation Year</span>
            <input
              className="input"
              value={form.graduation_year}
              onChange={(e) => setForm((prev) => ({ ...prev, graduation_year: e.target.value }))}
              placeholder="e.g. 2027"
            />
          </label>

          <label className="stack" style={{ gap: 4 }}>
            <span className="help">Age Group</span>
            <input
              className="input"
              value={form.age_group}
              onChange={(e) => setForm((prev) => ({ ...prev, age_group: e.target.value }))}
              placeholder="e.g. U17"
            />
          </label>

          {error && (
            <div className="help" style={{ color: "red" }}>
              {error}
            </div>
          )}

          <div className="row" style={{ justifyContent: "flex-end", marginTop: 16, gap: 8 }}>
            <button type="button" className="btn ghost" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn" onClick={handleSubmit} disabled={saving}>
              {saving ? "Creating…" : "Create User"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
